<div class="loading-container" *ngIf="loading">
  <mat-progress-bar mode="indeterminate" class="custom-progress"></mat-progress-bar>
</div>

<div *ngIf="!loading" class="container-fluid py-2 main-container fade-in">

  <ng-container *ngIf="surveyQuestionHistories?.length; else noDataTemplate">

    <div class="questions-list">
      <div *ngFor="let history of surveyQuestionHistories; let i = index" class="mb-4">
        <app-question-history-dashboard [questionHistory]="history"></app-question-history-dashboard>
      </div>
    </div>

    <div class="paginator-wrapper d-flex justify-content-center mt-5">
      <mat-paginator
        (page)="onPageChange($event)"
        [length]="totalSurveyQuestionHistories"
        [pageIndex]="currentPageIndex"
        [pageSizeOptions]="[1, 5, 10]"
        [pageSize]="pageSize"
        class="custom-paginator shadow-sm"
        aria-label="Select page">
      </mat-paginator>
    </div>

  </ng-container>

  <ng-template #noDataTemplate>
    <div class="empty-state d-flex flex-column align-items-center justify-content-center p-5 text-center">
      <div class="icon-circle mb-3">
        <mat-icon>inbox</mat-icon>
      </div>
      <h5 class="text-dark font-weight-bold">Nessuna cronologia trovata</h5>
      <p class="text-muted">
        {{ "components.surveys.question-history-dashboard.no-question-history" | translate }}
      </p>
    </div>
  </ng-template>

</div>
